import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=2b336ed0&"
import script from "./Rewards.vue?vue&type=script&lang=ts&"
export * from "./Rewards.vue?vue&type=script&lang=ts&"
import style0 from "./Rewards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports